import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import {
    ResultadoEnvioMuestraLaboratorioViewModel,
    SolicitudLaboratorioViewModel,
    TwResultadoEnvioMuestraLaboratorioSolicitudViewModel,
    TwTcResultadoEnvioMuestraLaboratorioEnum,
} from '../laboratorio.types';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { DatePipe } from '@angular/common';
import { RegLaboratorioService } from '../../../../_mantenimiento/registros/laboratorios/laboratorio.service';
import { UsuarioViewModel } from '../../../../_mantenimiento/usuarios/usuarios.types';

@Component({
    selector: 'app-laboratorio-resultadoenviomuestras',
    templateUrl: './laboratorio-resultadoenviomuestras.component.html',
})
export class LaboratorioResultadoEnvioMuestrasComponent extends ComponentBase implements OnInit, OnChanges {
    public isCollapsedCabecera = false;

    idResultado: number;
    idTecnicoLaboratorio: number;
    fecha: Date;
    observaciones = '';

    tecnicoLaboratorioNombre = '';
    tecnicoLaboratorioApellidos = '';
    tecnicoLaboratorio = ``;

    tecnicoenvioMuestrasCerrado: UsuarioViewModel;

    @Input() idSolicitud = 0;
    @Input() formGroup: FormGroup;
    @Input() solicitudLaboratorio: SolicitudLaboratorioViewModel;
    @Input() esPerfilInspectorOrGrabador = false;
    @Input() esPerfilConsultasyLaboratorio = false;
    @Input() hayEnvioMuestrasInspector = false;
    @Input() listResultados: ResultadoEnvioMuestraLaboratorioViewModel[];
    @Input() hayResultadoMuestrasLaboratorio = false;
    @Input() resultadoMuestrasLaboratorio: TwResultadoEnvioMuestraLaboratorioSolicitudViewModel;
    @Input() envioMuestrasCerrado = false;

    constructor(
        private regLaboratorioService: RegLaboratorioService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        public datepipe: DatePipe,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.form = this.formGroup;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.resultadoMuestrasLaboratorio?.currentValue) {
            if (!this.esPerfilConsultasyLaboratorio) {
                this.formGroup.controls['IdResultado'].disable();
                this.formGroup.controls['ObservacionesResultado'].disable();
            }

            if (!this.esPerfilConsultasyLaboratorio && !this.hayResultadoMuestrasLaboratorio) {
                this.formGroup.patchValue({
                    IdResultado: TwTcResultadoEnvioMuestraLaboratorioEnum.Pendiente,
                });
            }

            if (this.hayResultadoMuestrasLaboratorio) {
                this.getResultadoLaboratorioData();
                this.updateForm();
            }

            if ((!this.esPerfilConsultasyLaboratorio && this.hayResultadoMuestrasLaboratorio && !this.envioMuestrasCerrado) || this.envioMuestrasCerrado) {
                this.getTecnicoEnvioMuestrasCerrado();
            }

            if (this.esPerfilConsultasyLaboratorio && !this.envioMuestrasCerrado) {
                this.idResultado = this.resultadoMuestrasLaboratorio.IdResultado;
                this.idTecnicoLaboratorio = this.loggedInUser!.Id;
                this.tecnicoLaboratorioNombre = this.loggedInUser!.Nombre;
                this.tecnicoLaboratorioApellidos = this.loggedInUser!.Apellidos;
                this.tecnicoLaboratorio = `${this.tecnicoLaboratorioNombre} ${this.tecnicoLaboratorioApellidos}`;
                this.updateForm();
            }
        }
    }

    getResultadoLaboratorioData() {
        this.idResultado = this.resultadoMuestrasLaboratorio.IdResultado;
        this.idTecnicoLaboratorio = this.resultadoMuestrasLaboratorio.IdTecnico!;
        this.fecha = this.resultadoMuestrasLaboratorio.FechaResultado!;
        this.observaciones = this.resultadoMuestrasLaboratorio.ObservacionesResultado;
    }

    private updateForm(): void {
        this.formGroup.patchValue({
            IdResultado: this.idResultado, //Desplegable con los valores de la TwTcResultadoEnvioMuestraLaboratorio
            IdTecnico: this.idTecnicoLaboratorio,
            IdTecnicoDescripcion: this.tecnicoLaboratorio, //Técnico de laboratorio con nombre y apellidos
            FechaResultado: this.datepipe.transform(this.fecha, 'dd/MM/yyyy') || null, //Fecha en la que el usuario guarde
            ObservacionesResultado: this.observaciones || '',
        });
    }

    private getTecnicoEnvioMuestrasCerrado(): void {
        this.regLaboratorioService.getTecnico(this.resultadoMuestrasLaboratorio.IdTecnico!).subscribe(res => {
            this.tecnicoenvioMuestrasCerrado = res;
            this.tecnicoLaboratorioNombre = this.tecnicoenvioMuestrasCerrado.Nombre;
            this.tecnicoLaboratorioApellidos = this.tecnicoenvioMuestrasCerrado.Apellidos;
            this.tecnicoLaboratorio = `${this.tecnicoLaboratorioNombre} ${this.tecnicoLaboratorioApellidos}`;

            this.formGroup.controls['IdResultado'].disable();
            this.formGroup.controls['ObservacionesResultado'].disable();

            this.updateForm();
        });
    }
}
